import React from "react";
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import styled from "styled-components";
import { format } from "date-fns";

const StyledTableCell = styled(TableCell)`
    font-size: 12px;
`;

const AnalysisHistoryTable = ({ data }) => {
    if (!data || data.length === 0)
        return <p style={{ fontSize: "12px", padding: "62px" }}>No history at the moment</p>;
    const [filterByStatus] = React.useState("all");
    const [filterByCategory] = React.useState("all");
    const [missionsHistory, setMissionsHistoryTeams] = React.useState(data);
    const createData = (name, started, finished, status, attempts, size, category) => {
        return { name, started, finished, status, attempts, size, category };
    };
    React.useEffect(() => {
        let tempMissions = data;
        if (filterByStatus !== "all") {
            tempMissions = tempMissions.filter((item) => item.status.includes(filterByStatus));
        }
        if (filterByCategory !== "all") {
            tempMissions = tempMissions.filter((item) => item.category.includes(filterByCategory));
        }
        setMissionsHistoryTeams(tempMissions);
    }, [filterByStatus, filterByCategory]);

    const rows = missionsHistory.map((mission) => {
        return createData(
            mission.title,
            mission.startDate,
            mission.endDate,
            mission.status,
            mission.attempts,
            mission.teamMembers,
            mission.category
        );
    });

    const stringFormatter = (str) => {
        const words = str.replace(/([A-Z])/g, " $1");
        const formattedWords = words.charAt(0).toUpperCase() + words.slice(1);
        return formattedWords;
    };
    return (
        <Paper sx={{ width: "100%", overflow: "hidden", borderRadius: "0px 0px 14px 14px" }}>
            <TableContainer>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>Name</StyledTableCell>
                            <StyledTableCell align="center">Date Created</StyledTableCell>
                            <StyledTableCell align="center">Context</StyledTableCell>
                            <StyledTableCell align="center">Status</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row) => (
                            <TableRow
                                key={row.missionId + row.startDate}
                                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                            >
                                <StyledTableCell component="th" scope="row">
                                    {row.name}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                    {format(new Date(row.started * 1000), "dd/MM/yyyy")}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                    {format(new Date(row.finished * 1000), "dd/MM/yyyy")}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                    {stringFormatter(row.status)}
                                </StyledTableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
};

export default AnalysisHistoryTable;
